import { render, staticRenderFns } from "./OrderGrid.vue?vue&type=template&id=6cb30643&scoped=true&"
import script from "./OrderGrid.vue?vue&type=script&lang=js&"
export * from "./OrderGrid.vue?vue&type=script&lang=js&"
import style0 from "./OrderGrid.vue?vue&type=style&index=0&id=6cb30643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb30643",
  null
  
)

/* custom blocks */
import block0 from "./OrderGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports